// Tarjetas de conteo de Inventario v3: cuentan y, al elegirlas, filtran la lista.
import { cn } from '@/lib/cn';
import { BUCKET_OPTIONS, formatInt, type BucketTone } from '../lib/inventoryFormat';
import type { StockBucket } from '../lib/inventoryList';

const TONE_CLASS: Record<BucketTone, string> = {
    neutral: 'text-foreground',
    success: 'text-success',
    danger: 'text-danger',
    muted: 'text-muted-foreground',
    warning: 'text-warning',
};

export function InventoryStatsBar({
    counts,
    active,
    onChange,
}: {
    counts: Record<StockBucket, number> | null;
    active: StockBucket;
    onChange: (bucket: StockBucket) => void;
}) {
    return (
        <div className="flex flex-none flex-wrap items-center gap-1 border-b border-border bg-muted/15 px-3 py-1.5">
            {BUCKET_OPTIONS.map((option) => {
                const isActive = option.value === active;
                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isActive}
                        title={option.hint}
                        onClick={() => {
                            onChange(option.value);
                        }}
                        className={cn(
                            'inline-flex min-w-0 flex-auto items-baseline justify-center gap-[5px] whitespace-nowrap rounded-[5px] border px-1.5 py-1 transition-colors',
                            isActive
                                ? 'border-primary bg-accent'
                                : 'border-border bg-card hover:bg-accent/50',
                        )}
                    >
                        <span
                            className={cn(
                                'truncate text-[9.5px] font-bold uppercase tracking-[0.05em]',
                                isActive ? 'text-foreground' : 'text-muted-foreground',
                            )}
                        >
                            {option.label}
                        </span>
                        <span
                            className={cn(
                                'text-[12px] font-bold tabular-nums',
                                TONE_CLASS[option.tone],
                            )}
                        >
                            {counts ? formatInt(counts[option.value]) : '—'}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
